import {
  notificationPath,
  notificationPathParts,
  resolveNotificationLink,
  notificationLabel,
  getNotificationGroup,
  notificationBody,
} from './nativeModel';
import copy from './copy.json';
export const translate = (locale, key, vars = {}) =>
  String(copy[locale === 'en' ? 'en' : 'ko'][key] || key).replace(
    /\{\{(\w+)\}\}/g,
    (_, k) => vars[k] ?? '',
  );
export const visibleNotifications = (items) => {
  if (!Array.isArray(items)) throw Error('Invalid notification list');
  return items.filter(
    (n) => n.type !== 'COMMENT_ON_NEWS' && notificationPathParts(n.link)[0] !== 'news',
  );
};
export const unreadCount = (items) => items.filter((n) => !n.isRead).length;
export function notificationGroups(items, locale, now = new Date()) {
  const groups = new Map(),
    t = (k, v) => translate(locale, k, v);
  for (const item of items) {
    const group = getNotificationGroup(item.createdAt, locale, t, now);
    if (!groups.has(group.key)) groups.set(group.key, { ...group, items: [] });
    groups.get(group.key).items.push(item);
  }
  return [...groups.values()];
}
export function notificationText(item, locale) {
  const t = (k, v) => translate(locale, k, v);
  return {
    title:
      item.type === 'NEW_RELEASES' && item.actorNicknameSnapshot?.trim()
        ? t('notifications.title.interestedArtistRelease', {
            artist: item.actorNicknameSnapshot.trim(),
          })
        : notificationLabel[item.type]
          ? t(notificationLabel[item.type])
          : item.type,
    body: notificationBody(item, t, locale),
  };
}
export function webDestination(link) {
  const path = notificationPath(link),
    target = resolveNotificationLink(link);
  if (!target || !path || path.startsWith('//') || path.includes('\\')) return null;
  const query = path.includes('?') ? '?' + path.split('?').slice(1).join('?') : '';
  const p = target.params,
    enc = encodeURIComponent;
  switch (target.name) {
    case 'MainTabs':
      return { Home: '/', My: '/mypage', Explore: '/explore' }[p.screen];
    case 'AlbumList':
      return `/albums?category=${p.category}&region=${p.region}`;
    case 'Notifications':
      return '/notifications';
    case 'Sponsorship':
      return '/sponsorship';
    case 'NoticeList':
      return '/notice';
    case 'AlbumDetail':
      return '/reviews/' + enc(p.albumSlug) + query;
    case 'LegacyAlbumDetail':
      return '/reviews/local/' + enc(p.sourceId) + query;
    case 'UserReviewDetail':
    case 'UserReviewComment': {
      const slug = p.albumSlug.startsWith('local/')
        ? 'local/' + enc(p.albumSlug.slice(6))
        : enc(p.albumSlug);
      return (
        `/reviews/${slug}/user-reviews/${enc(p.reviewId)}` +
        (p.commentId ? '/comment/' + enc(p.commentId) : '') +
        query
      );
    }
    case 'PlaylistDetail':
    case 'PlaylistComment':
      return '/lists/' + enc(p.slug) + (p.commentId ? '/comment/' + enc(p.commentId) : '') + query;
    case 'UserProfile':
      return '/users/' + enc(p.nickname);
    case 'NoticeDetail':
    case 'NoticeComment':
      return '/notice/' + enc(p.slug) + (p.commentId ? '/comment/' + enc(p.commentId) : '') + query;
    default:
      return null;
  }
}
// SSE event fields must persist across transport chunks; a chunk is not an event.
export function createNotificationStream(onEvent) {
  let buffer = '',
    event = '',
    data = [];
  return (chunk) => {
    buffer += chunk;
    let i;
    while ((i = buffer.indexOf('\n')) >= 0) {
      const line = buffer.slice(0, i).replace(/\r$/, '');
      buffer = buffer.slice(i + 1);
      if (!line) {
        if (event === 'notification' && data.length) onEvent(data.join('\n'));
        event = '';
        data = [];
      } else if (line.startsWith('event:')) event = line.slice(6).trim();
      else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
    }
  };
}
